import React,{useEffect} from 'react'
import "./about.css"

import Aos from 'aos';
import 'aos/dist/aos.css';


import img10 from "../../assets/about/mountain.png"
import img11 from "../../assets/about/medina.png"
import img12 from "../../assets/about/souk.png"

import video from "../../assets/about/jamaalfna.mp4"

const About = () => {

  useEffect(()=>{
    Aos.init({duration:2000});
  },[])


  return (
    <div id='About'>
      <section className="about section">
        <div className="secContainer">
          <div data-aos="fade-down" data-aos-duration="2000" className="title">
            <h2>Why Explore Morocco?</h2>
          </div>
          <div className="mainContent container grid">
            <div data-aos="fade-up" data-aos-duration="2000" className="singleItem">
              <img src={img10} alt="Image Name" />
              <h3>Majestic Mountains</h3>
              <p>
                Conquer Morocco's towering peaks and soak in breathtaking vistas.
              </p>
            </div>
            <div data-aos="fade-up" data-aos-duration="2500" className="singleItem">
              <img src={img11} alt="Image Name" />
              <h3>Ancient Medinas</h3>
              <p>
                Step back in time and wander through Morocco's historic medinas.
              </p>
            </div>
            <div data-aos="fade-up" data-aos-duration="3000" className="singleItem">
              <img src={img12} alt="Image Name" />
              <h3>Vibrant Souks</h3>
              <p>
                Get lost in Morocco's bustling markets and indulge in vibrant culture.
              </p>
            </div>
          </div>
          <div className="videoCard container">
            <div className="cardContent grid">
              <div data-aos="fade-right" data-aos-duration="2000" className="cardText">
                <h2>Experience Morocco's Beauty!</h2>
                <p>Let the sights and sounds of Morocco captivate your senses and leave you spellbound.</p>
              </div>
              <div data-aos="fade-left" data-aos-duration="2000" className="cardVideo">
                <video src={video} autoPlay loop muted typeof='video/mp4'></video>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default About